export default "__VITE_ASSET__BdHmDlpS__"